
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { ButtonBase, Grid2, Link, Stack } from '@mui/material';
import Container from '@mui/material/Container';
import { loadBalance } from '../functions/loadBalance';
import './icons.css'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';



export default function Footer() {


  return (
    <React.Fragment>
      <Container maxWidth="true" sx={{ py: 10 }} className="header-hero">
        <Container maxWidth={'xl'} sx={{ position: 'relative', zIndex: 2 }}>

          <Grid2 container justifyContent={'space-between'} spacing={10}>

            <Grid2 size={{ xs: 12, lg: 6 }}>
              <Stack
                direction={{ xs: "column", lg: "column" }}
                spacing={{ xs: 1, sm: 2, md: 0 }}
                justifyContent={{ xs: "center", lg: "space-around" }}
                alignItems="center"
              >
                <ButtonBase onClick={() => { loadBalance("REACT_APP_HOME", "") }}>
                  <Typography
                    variant="h3"
                    sx={{ color: (theme) => theme.palette.text.primary }}
                    className="notranslate">
                    CALLGOOSE
                  </Typography>
                </ButtonBase>

                <Typography variant="caption" sx={{ fontWeight: 200 }}>
                  &copy; 2026 Callgoose.com. All rights reserved
                </Typography>

                <Stack direction="row" spacing={1} alignItems="center" justifyContent={'center'}>

                  <ButtonBase onClick={() => { loadBalance("REACT_APP_HOME", "") }}>
                    <Typography variant="caption" sx={{ fontWeight: 200 }}>Privacy Policy</Typography>
                  </ButtonBase>

                  <Typography variant="caption" sx={{ mx: 0 }}>&#9474;</Typography>

                  <ButtonBase onClick={() => { loadBalance("REACT_APP_HOME", "") }}>
                    <Typography variant="caption" sx={{ fontWeight: 200 }}>Terms of use</Typography>
                  </ButtonBase>

                </Stack>

              </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, lg: 6 }}>
              <Stack
                direction={{ xs: "column", lg: "column" }}
                spacing={{ xs: 1, sm: 2, md: 0 }}
                justifyContent={{ xs: "center", lg: "space-around" }}
                alignItems="center"
              >

                  <Stack component="ul" class="wrapper" >

                    <li class="icon tiktok">
                      <Link href={process.env.REACT_APP_TIKTOK} color="inherit" target="_blank">
                        <span class="tooltip">TikTok</span>
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="38" height="38" viewBox="0 0 30 30">
                            <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.104,4,24,4z M22.689,13.474 c-0.13,0.012-0.261,0.02-0.393,0.02c-1.495,0-2.809-0.768-3.574-1.931c0,3.049,0,6.519,0,6.577c0,2.685-2.177,4.861-4.861,4.861 C11.177,23,9,20.823,9,18.139c0-2.685,2.177-4.861,4.861-4.861c0.102,0,0.201,0.009,0.3,0.015v2.396c-0.1-0.012-0.197-0.03-0.3-0.03 c-1.37,0-2.481,1.111-2.481,2.481s1.11,2.481,2.481,2.481c1.371,0,2.581-1.08,2.581-2.45c0-0.055,0.024-11.17,0.024-11.17h2.289 c0.215,2.047,1.868,3.663,3.934,3.811V13.474z"></path>
                          </svg>
                        </span>
                      </Link>
                    </li>

                    <li class="icon linkedin">
                      <Link href={process.env.REACT_APP_LINKEDIN} color="inherit" target="_blank">
                        <span class="tooltip">LinkedIn</span>
                        <span><LinkedInIcon fontSize='large'/></span>
                      </Link>
                    </li>
                    <li class="icon twitter">
                      <Link href={process.env.REACT_APP_TWITTER} color="inherit" target="_blank">
                        <span class="tooltip">Twitter</span>
                        <span><XIcon /></span>
                      </Link>
                    </li>
                    <li class="icon instagram">
                      <Link href={process.env.REACT_APP_INSTAGRAM} color="inherit" target="_blank">
                        <span class="tooltip">Instagram</span>
                        <span>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32" viewBox="0 0 30 30">
    <path d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z"></path>
</svg>
                        </span>
                      </Link>
                    </li>

                    <li class="icon youtube">
                      <Link href={process.env.REACT_APP_YOUTUBE} color="inherit" target="_blank">
                        <span class="tooltip">Youtube</span>
                        <span><YouTubeIcon fontSize='large' /></span>
                      </Link>
                    </li>

                    <li class="icon medium">
                      <Link href={process.env.REACT_APP_MEDIUM} color="inherit" target="_blank">
                        <span class="tooltip">Medium</span>
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 50 50">
                            <path d="M15 12A13 13 0 1015 38 13 13 0 1015 12zM35.5 13c-3.59 0-6.5 5.373-6.5 12 0 1.243.102 2.441.292 3.568.253 1.503.662 2.879 1.192 4.065.265.593.56 1.138.881 1.627.642.978 1.388 1.733 2.202 2.201C34.178 36.811 34.827 37 35.5 37s1.322-.189 1.933-.539c.814-.468 1.56-1.223 2.202-2.201.321-.489.616-1.034.881-1.627.53-1.185.939-2.562 1.192-4.065C41.898 27.441 42 26.243 42 25 42 18.373 39.09 13 35.5 13zM45.5 14c-.259 0-.509.173-.743.495-.157.214-.307.494-.448.833-.071.169-.14.353-.206.551-.133.395-.257.846-.37 1.343-.226.995-.409 2.181-.536 3.497-.063.658-.112 1.349-.146 2.065C43.017 23.499 43 24.241 43 25s.017 1.501.051 2.217c.033.716.082 1.407.146 2.065.127 1.316.31 2.501.536 3.497.113.498.237.948.37 1.343.066.198.135.382.206.551.142.339.292.619.448.833C44.991 35.827 45.241 36 45.5 36c1.381 0 2.5-4.925 2.5-11S46.881 14 45.5 14z"></path>
                          </svg>
                        </span>
                      </Link>
                    </li>

                  </Stack>


              </Stack>
            </Grid2>

          </Grid2>

        </Container>
      </Container>
    </React.Fragment>
  );
}
